var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningDiffEquals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H17C19.2091 0 21 1.79086 21 4V16C21 18.2091 19.2091 20 17 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#E7DAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 11.556H13.06V12.366H7.9V11.556ZM7.9 9.546H13.06V10.356H7.9V9.546Z",
    fill: "#4D0891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDiffEquals);
export default __webpack_public_path__ + "static/media/warningDiffEquals.5d67149f2165c739c17f9768b5dd2199.svg";
export { ForwardRef as ReactComponent };